import {IBoosterBenchmark} from "../../../../../../store/reducers/booster.reducer";

export class BoosterBenchmark implements IBoosterBenchmark {
  serverPerformance: number;
  wordpressPerformance: number;
  phpVersion: number;
  mysqlVersion: number;

  constructor(benchmark) {
    this.serverPerformance = benchmark && benchmark.system && benchmark.system && benchmark.system.total && round(benchmark.system.total) || 0;
    this.wordpressPerformance = benchmark && benchmark.wordpress && benchmark.wordpress.time && round(benchmark.wordpress.time) || 0;
    this.phpVersion = benchmark && benchmark.system && benchmark.system.sysinfo && benchmark.system.sysinfo.php_version && round(formatVersion(benchmark.system.sysinfo.php_version)) || 0;
    this.mysqlVersion = benchmark && benchmark.system && benchmark.system.sysinfo && benchmark.system.sysinfo.mysql_version && round(formatVersion(benchmark.system.sysinfo.mysql_version)) || 0;
  }

}

function round(value): number {
  return Math.round(value * 10) / 10;
}

function formatVersion(version): string {
  return version.match(/\d+\.\d+/)[0];
}
